<template>
    <div ref="adContainer" id="ad-container" style="height: 500px; width: 100%"></div>
</template>

<script>
export default {
    name: 'AdsGoogle',
    props: ['slot'],
    mounted(){
        this.$nextTick(() => {
            this.loadAd();
        });
    },
    methods: {
        loadAd() {
            var self = this;
            var slot = '1190427199';
            const adContainer = this.$refs.adContainer;
            if (!adContainer) {
                return
            }
            // Clear any existing ads
            adContainer.innerHTML = '';

            // Create a new <ins> element
            const insElement = document.createElement('ins');
            insElement.className = 'adsbygoogle';
            insElement.style.display = 'block';
            if (window.innerWidth > 767) {
                insElement.style.width = '160px';
                insElement.style.height = '600px';
                slot = '7203542527';
            }
            
            insElement.setAttribute('data-ad-client', 'ca-pub-1418014173390726');
            insElement.setAttribute('data-ad-slot', this.slot || slot);
            insElement.setAttribute('data-ad-format', 'auto');
            insElement.setAttribute('data-full-width-responsive', 'true');

            // Append the new <ins> element
            adContainer.appendChild(insElement);
            
            // Initialize the ad
            try {
                // eslint-disable-next-line no-undef
                (adsbygoogle = window.adsbygoogle || []).push({});
            } catch (error) {
                setTimeout(function(){
                    self.loadAd(); // Recreate and reload the ad
                }, 1000)
                return;
            }

            // Check if the current <ins> tag has "unfilled" status
            setTimeout(function(){
                const currentIns = adContainer.querySelector('ins');
                const adStatus = currentIns.getAttribute('data-ad-status');
                if (currentIns && (adStatus === 'unfilled' || adStatus === null)) {
                    self.loadAd(); // Recreate and reload the ad
                }
            }, 10000)
        },
    },
}
</script>
<style>
.columns {
    position: relative;
}
@media (min-width: 769px) {
    .is-scroll-top .banner-on-top {
        position: sticky !important;
        top: 60px !important;
    }
}
</style>